import PhoneUtil from 'gw-portals-util-angular/PhoneUtil';

export default [
    'LocaleService',
    LocaleService => number => PhoneUtil(LocaleService).prettyPrint(number)
];
